/**
 * Created by eladd on 8/31/2017.
 */
import {Pipe, PipeTransform} from "@angular/core";
import * as _ from "lodash";

@Pipe({
	name: 'cpSkip',
	pure:true
})
export class SkipPipe implements PipeTransform {
	transform(array: any[], skipItems:number) {
		if (!array){
			return array;
		}
		return array.filter((x,i)=>i>=skipItems);
	}
}
